module.exports = __webpack_public_path__ + "img/line.32ecd859.svg";